/** Session keys — keep separate per surface (modal vs floating vs sidebar). */
const MODAL_DISMISSED_PREFIX = "onboarding_modal_dismissed_";
const FLOATING_DISMISSED_PREFIX = "onboarding_floating_dismissed_";
const SIDEBAR_DISMISSED_PREFIX = "onboarding_sidebar_dismissed_";
const RESET_ON_LOGIN_KEY = "onboarding_widgets_reset_on_login";

const ONBOARDING_DISMISS_PREFIXES = [
  MODAL_DISMISSED_PREFIX,
  FLOATING_DISMISSED_PREFIX,
  SIDEBAR_DISMISSED_PREFIX,
];

export const getOnboardingModalDismissedKey = (userId) =>
  `${MODAL_DISMISSED_PREFIX}${userId}`;

export const getOnboardingFloatingDismissedKey = (userId) =>
  `${FLOATING_DISMISSED_PREFIX}${userId}`;

export const getOnboardingSidebarDismissedKey = (userId) =>
  `${SIDEBAR_DISMISSED_PREFIX}${userId}`;

export const clearOnboardingSessionDismissState = (userId) => {
  if (!userId) {
    return;
  }
  try {
    sessionStorage.removeItem(getOnboardingModalDismissedKey(userId));
    sessionStorage.removeItem(getOnboardingFloatingDismissedKey(userId));
    sessionStorage.removeItem(getOnboardingSidebarDismissedKey(userId));
  } catch (_) {
    // ignore
  }
};

export const clearAllOnboardingWidgetDismissState = () => {
  try {
    Object.keys(sessionStorage)
      .filter((key) =>
        ONBOARDING_DISMISS_PREFIXES.some((prefix) => key.startsWith(prefix))
      )
      .forEach((key) => sessionStorage.removeItem(key));
    markOnboardingWidgetResetOnNextLogin();
  } catch (_) {
    // ignore
  }
};

/** Persisted across logout so the next login can restore setup UI. */
export const markOnboardingWidgetResetOnNextLogin = () => {
  try {
    sessionStorage.setItem(RESET_ON_LOGIN_KEY, "true");
  } catch (_) {
    // ignore
  }
};

export const consumeOnboardingWidgetResetOnLogin = (userId) => {
  if (!userId) {
    return false;
  }
  try {
    const shouldReset = sessionStorage.getItem(RESET_ON_LOGIN_KEY) === "true";
    if (!shouldReset) {
      return false;
    }
    sessionStorage.removeItem(RESET_ON_LOGIN_KEY);
    clearOnboardingSessionDismissState(userId);
    return true;
  } catch (_) {
    return false;
  }
};

export const readOnboardingModalDismissed = (userId) => {
  if (!userId) {
    return false;
  }
  try {
    return sessionStorage.getItem(getOnboardingModalDismissedKey(userId)) === "true";
  } catch (_) {
    return false;
  }
};

export const readOnboardingFloatingDismissed = (userId) => {
  if (!userId) {
    return false;
  }
  try {
    return sessionStorage.getItem(getOnboardingFloatingDismissedKey(userId)) === "true";
  } catch (_) {
    return false;
  }
};

export const readOnboardingSidebarDismissed = (userId) => {
  if (!userId) {
    return false;
  }
  try {
    return sessionStorage.getItem(getOnboardingSidebarDismissedKey(userId)) === "true";
  } catch (_) {
    return false;
  }
};

export const writeOnboardingModalDismissed = (userId) => {
  if (!userId) {
    return;
  }
  try {
    sessionStorage.setItem(getOnboardingModalDismissedKey(userId), "true");
  } catch (_) {
    // ignore
  }
};

export const writeOnboardingFloatingDismissed = (userId) => {
  if (!userId) {
    return;
  }
  try {
    sessionStorage.setItem(getOnboardingFloatingDismissedKey(userId), "true");
  } catch (_) {
    // ignore
  }
};

export const writeOnboardingSidebarDismissed = (userId) => {
  if (!userId) {
    return;
  }
  try {
    sessionStorage.setItem(getOnboardingSidebarDismissedKey(userId), "true");
  } catch (_) {
    // ignore
  }
};
